import gql from 'graphql-tag';

export default gql`
query ($id: Int) {
  project_activity_budget(project_activity_budget_id: $id){
    id
    user_project_activities{
      user_project_activity_id
      user{
        user_id
        full_name
      }
      timesheets{
        id
        user_id
        hours_worked
        role_hourly_rate
      }
    }
  }
}
`